<div class="address-actions"
     [class.address-actions--opened]="isActionsOpened">
    <button
        class="address-actions__opening-button"
        (click)="onActionsOpenClick()"
        [mmTestTarget]="'opening-button'">
        <mm-icon class="address-actions__opening-button-icon" name="dot-three-horizontal"></mm-icon>
        <span *appShowFor="'mm-desktop'" class="address-actions__opening-button-tooltip">
            {{ tooltipLabel | translate }}
        </span>
    </button>
    <div *ngIf="isActionsOpened" class="address-actions__actions-container">
        <div class="address-actions__list">
            <button *ngFor="let action of actionList"
                    [class]="'address-actions__action-button address-actions__action-button--' + action.type"
                    [class.address-actions__action-button--inactive]="action.isDisabled"
                    (click)="!action.isDisabled && onActionClick(action.type)"
                    [mmTestTarget]="action.type + '-button'">
                {{ action.label | translate }}
            </button>
        </div>
    </div>
</div>
